import { render, staticRenderFns } from "./PhotoCard.vue?vue&type=template&id=beebf5a0&scoped=true&"
import script from "./PhotoCard.vue?vue&type=script&lang=js&"
export * from "./PhotoCard.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCard.vue?vue&type=style&index=0&id=beebf5a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beebf5a0",
  null
  
)

export default component.exports